'use client';

import { z } from 'zod';

import LayoutContainer from '~/components/molecules/LayoutContainer';
import MainFooterNav from '~/components/organisms/footer/MainFooterNav';
import { modelMenu } from '~/lib/api/models';
import { useHydrationSafeResponsive } from '~/lib/hooks/useResponsive';
import { cn } from '~/lib/utils/classname';

interface MainFooterClientProps {
  horizontal?: boolean;
  data: z.infer<typeof modelMenu.schema>;
}

const MainFooterClient: React.FC<MainFooterClientProps> = ({
  horizontal: sourceHorizontal,
  data,
}) => {
  const isMobile = useHydrationSafeResponsive('mobile');
  const horizontal = sourceHorizontal && !isMobile;

  return (
    <LayoutContainer
      classNames={{
        main: cn({
          'h-full w-screen': horizontal,
        }),

        inner: cn('flex flex-col items-center justify-between', {
          'min-h-comp-h gap-y-20 max-lg:min-h-auto': !horizontal,
          'h-full': horizontal,
        }),
      }}
    >
      <MainFooterNav menu={data.menu} />
    </LayoutContainer>
  );
};

export default MainFooterClient;
